__turbopack_context__.v({
  "appColumn": "ConnectionsTable-module__Z8DLmq__appColumn",
  "countColumnLabel": "ConnectionsTable-module__Z8DLmq__countColumnLabel",
});
